import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import {
    getUsers
} from "../../store/action/user";
import AdminUserTable from "../../components/tables/AdminUserTable";

const AdminUser = () => {
    const { token } = isAuthenticated();
    const [ loading, setloading ] = useState(true);
    const [ users , setUsers ] = useState([]);

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const res = await getUsers(token);
            if (res.success) {
                const users = res.users.reduce((r,i) => {
                    r.push({
                        id:i.id,
                        firstName:i.first_name,
                        lastName:i.last_name,
                        email:i.email,
                        phone:i.phone,
                        organizationName:i.organization_name,
                        role:i.role,
                        totalKeys:i.keys.length,
                        keys:i.keys,
                        walletType:i.wallet_type,
                        walletBalance:i.wallet_balance
                    });
                    return r;
                },[]);
                setUsers(users)
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setloading(false)
    };


    return (
        <div className="bg-white rounded shadow">
            <div className="p-4 d-flex justify-content-between">
                <h5>List Semua User</h5>
            </div>
            <AdminUserTable
                data={users}
                loading={loading}
            />
        </div>
    )
};


export default AdminUser;
